import {  
  loadDashboardDataInProgress,
  loadDashboardDataSuccess,
  loadDashboardDataFailure,
  loadDashboardWidgetsListSuccess,
  dashboardOperationCompleted,
  loadDashboardUserWidgetsListSuccess
} from "../state/dashboard/actions";
import { oktaAuth } from '../auth/okta';
import swal from 'sweetalert';
import { errorSweetAlert } from "../components/SweetAlertMessages";
const serverBasePath = process.env.REACT_APP_SERVER_API_URL;


export const loadWidgetsData = (id) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadDashboardDataInProgress());
    const response = await fetch(serverBasePath+"/dashboard/"+id+"/widget",
    {
      method: "GET",
      headers: {
        Authorization: 'Bearer ' +  token,
        'Content-Type': 'application/json',
      }
    });
    const data = await response.json();
    dispatch(dashboardOperationCompleted());
    if(response.status !== 200){
      swal("Error", data.error.message, "error");
      return;
    }  
    dispatch(loadDashboardDataSuccess(data));
  } catch (e) {
    dispatch(loadDashboardDataFailure());
    errorSweetAlert(e);
  }
};

export const loggedUserWidgetsData = () => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadDashboardDataInProgress());
    const response = await fetch(serverBasePath+"/dashboard/getUserWidgetData",
    {
      method: "GET",
      headers: {
        Authorization: 'Bearer ' +  token,
        'Content-Type': 'application/json',
      }
    });   
    const data = await response.json();
    dispatch(dashboardOperationCompleted());
    if(response.status !== 200){
      swal("Error", data.error.message, "error");
      return;
    }
    dispatch(loadDashboardUserWidgetsListSuccess(data));
  } catch (e) {
    dispatch(loadDashboardDataFailure());
    errorSweetAlert(e);
  }
};

export const loadWidgetsList = () => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadDashboardDataInProgress());
    const response = await fetch(serverBasePath+"/dashboard/getWidgetsList",
    {
      method: "GET",
      headers: {
        Authorization: 'Bearer ' +  token,
        'Content-Type': 'application/json',
      }
    });
    const data = await response.json();
    dispatch(dashboardOperationCompleted());
    if(response.status !== 200){
      swal("Error", data.error.message, "error");
      return;
    }   
    dispatch(loadDashboardWidgetsListSuccess(data));
  } catch (e) {
    dispatch(loadDashboardDataFailure());
    errorSweetAlert(e);
  }
};

export const saveUserWidgetsData  = (layout) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadDashboardDataInProgress());
    const response = await fetch(serverBasePath+"/dashboard/updateUsersWidgetData",
    {
      method: "POST",
      headers: {
        Authorization: 'Bearer ' + token,   
        'Content-Type': 'application/json',   
      },
      body:JSON.stringify(layout)
    });   
    dispatch(dashboardOperationCompleted());
    const result = await response.json();
    if(response.status !== 200){
      swal("Error", result.error.message, "error");
      return;
    } 
    if(response.status === 200){
      swal("Success", result.message, "success");
      return;
    }
  } catch (e) {
    dispatch(loadDashboardDataFailure());
    errorSweetAlert(e);
  }
};

export const deleteUserWidgetsData  = (widgetId) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadDashboardDataInProgress());
    const response = await fetch(serverBasePath+"/dashboard/deleteUserWidgetsData",
    {
      method: "PUT",
      headers: {
        Authorization: 'Bearer ' + token,   
        'Content-Type': 'application/json', 
        //'x-client-type' : 'web',  
      },
      body:JSON.stringify({'widgetId': widgetId})
    });   
    dispatch(dashboardOperationCompleted());
    const result = await response.json();
    if(response.status !== 200){
      swal("Error", result.error.message, "error");
      return;
    } 
    if(response.status === 200){
      swal("Success", result.message, "success");
      return;
    }
  } catch (e) {
    dispatch(loadDashboardDataFailure());
    errorSweetAlert(e);
  }
};
